import { render, staticRenderFns } from "./EditarConvocatoriasDialogComponent.vue?vue&type=template&id=11d6cf6d"
import script from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports